// extracted by mini-css-extract-plugin
module.exports = {"formSelectMenu":"OptionTitle_formSelectMenu__nFLsr","greyColor":"OptionTitle_greyColor__519VP","optionTitle":"OptionTitle_optionTitle__9vUej"};